/* eslint-disable react/no-array-index-key */
import {
  Box,
  Button,
  Typography,
  Stack,
  Card,
  CardContent,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import TaskAltIcon from '@mui/icons-material/TaskAlt';
import productThumbnails from '../../products-page/constants/productThumbnails';

// Simulated confirmation data (replace with real data if needed)
const mockReceipt = {
  items: [
    {
      productId: 'beauty-box',
      name: 'Beauty Box',
      quantity: 1,
      price: 199,
      platform: 'Windows',
      hostApp: 'Adobe After Effects',
    },
    {
      productId: 'flicker-free',
      name: 'Flicker Free',
      quantity: 2,
      price: 289,
      platform: 'Macintosh',
      hostApp: 'Resolve',
    },
  ],
  discountCode: '25OFF',
  discountAmount: 144.5,
  subtotal: 777,
  total: 632.5,
};

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const { items, subtotal, discountCode, discountAmount, total } = mockReceipt;

  return (
    <Box sx={{ maxWidth: '800px', mx: 'auto', p: 4 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 48 }} />
        <Typography variant="h4">Purchase Confirmed</Typography>
        <Typography variant="body1">
          {/* A confirmation email has been sent. You can access your downloads from
          your account. */}
          A confirmation email has been sent to you. You can access your
          downloads or license details in your account dashboard.
        </Typography>
      </Stack>

      {/* <Stack spacing={2} alignItems="center" textAlign="center">
  <ReceiptLongIcon color="primary" sx={{ fontSize: 48 }} />
  <Typography variant="h4">
    Thank You for Your Order
  </Typography>
  <Typography variant="body1">
    Your receipt and download instructions have been sent to your email.
  </Typography>
</Stack>





<Stack spacing={2} alignItems="center" textAlign="center">
  <TaskAltIcon color="success" sx={{ fontSize: 48 }} />
  <Typography variant="h4">
    Order Complete
  </Typography>
  <Typography variant="body1">
    You're all set! Check your inbox for your license and downloads.
  </Typography>
</Stack> */}

      {/* <Typography variant="h4" gutterBottom align="center">
        🎉 Purchase Complete
      </Typography> */}
      {/* <Typography variant="h4" gutterBottom align="center">
        Thank You for Your Purchase
      </Typography> */}

      {/* <Typography variant="h4" gutterBottom align="center">
        Your Order Was Successfully Placed
      </Typography>

      <Typography variant="h4" gutterBottom align="center">
        Purchase Confirmed
      </Typography>

      <Typography variant="h4" gutterBottom align="center">
        Thank You — Your Purchase Is Confirmed
      </Typography> */}

      {/* <Typography variant="body1" align="center" sx={{ mt: 1 }}>
        A confirmation email has been sent to you. You can access your downloads
        or license details in your account dashboard.
      </Typography> */}

      {/* <Typography variant="body1" align="center" sx={{ mb: 2 }}>
        Thank you for your order. A confirmation email has been sent.
      </Typography> */}

      <Card sx={{ mt: 4, mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Receipt
          </Typography>

          {items.map((item, index) => {
            const thumbnail = productThumbnails.get(item.productId) ?? '';
            return (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  mb: 3,
                }}
              >
                <img
                  src={thumbnail}
                  alt={item.name}
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 4,
                    objectFit: 'contain',
                    border: '1px solid #ccc',
                  }}
                />
                <Box>
                  <Typography fontWeight="bold">{item.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    ${item.price.toFixed(2)} × {item.quantity}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Platform: {item.platform} | Host App: {item.hostApp}
                  </Typography>
                </Box>
              </Box>
            );
          })}

          <Divider sx={{ my: 2 }} />

          <Stack spacing={1}>
            <Typography>Subtotal: ${subtotal.toFixed(2)}</Typography>
            {discountAmount > 0 && (
              <Typography color="green">
                Discount ({discountCode}): –${discountAmount.toFixed(2)}
              </Typography>
            )}
            <Typography variant="h6">Total: ${total.toFixed(2)}</Typography>
          </Stack>
        </CardContent>
      </Card>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="center"
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </Button>
        <Button variant="outlined" onClick={() => navigate('/products')}>
          Continue Shopping
        </Button>
      </Stack>

      <Box mt={5} textAlign="center">
        <Typography variant="body2">
          Trouble finding your downloads? Check your <b>Spam</b> folder or email{' '}
          <a href="mailto:sales@digitalanarchy.com">sales@digitalanarchy.com</a>
          .
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfirmationPage;
